import { render } from "./OutletCard.vue?vue&type=template&id=2b29236e"
import script from "./OutletCard.vue?vue&type=script&lang=js"
export * from "./OutletCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__